import React from 'react';
import { LoginForm } from '../../components/LoginForm';

export function LoginPage() {
  return (
    <div className="min-h-screen bg-gray-950 flex items-center justify-center p-4">
      <LoginForm />
    </div>
  );
}
